/**
 * 解析輸入字串，回傳「顯示的字串」或 null。
 * - 僅做字串格式整理
 * - 不轉成 number
 * - 支援 "."、"12."、"0." 等輸入狀態
 */
export function parseDecimalInput(rawValue) {
  // 1. 空字串 → 回傳 ""（代表使用者清空）
  if (rawValue === "") return "";

  // 2. 驗證格式（允許輸入中的狀態）
  const decimalRegex = /^(\d+\.?\d*|\.\d*)$/;
  if (!decimalRegex.test(rawValue)) return null;

  let display = rawValue;

  // 3. "." → "0."
  if (display === ".") display = null;

  // 4. 處理 ".5" → "0.5"
  if (display?.startsWith(".")) {
    display = "0" + display;
  }

  // 5. 移除前導零（但保留 "0."）
  if (!display?.startsWith("0.") && !display?.startsWith(".")) {
    display = display?.replace(/^0+(?=\d)/, "");
  }

  // 6. 限制小數 4 位
  if (display?.includes(".")) {
    const [intPart, decPart = ""] = display?.split(".");
    display = intPart + "." + decPart.slice(0, 4);
  }

  // 7. 禁止負數
  if (display?.startsWith("-")) return null;

  return display;
}
